import { getPricingPlansPublicAPI } from '@wix/pricing-plans-tpa-api';
import { OP_APP_DEF_ID } from '../appDefId';

export const navigateToPaidPlans = async ({
  pageId,
  planIds,
  url,
  titleText,
  buttonText,
  contentText,
  wixCodeApi,
}: {
  pageId: string;
  url: string;
  planIds: string[];
  titleText: string;
  buttonText: string;
  contentText: string;
  wixCodeApi: any;
}) => {
  const pricingPlansApi = await getPricingPlansPublicAPI(wixCodeApi);

  return pricingPlansApi.navigateToPricingPage({
    planIds,
    biOptions: { referralInfo: 'challenges' },
    checkout: {
      thankYouPage: {
        content: { title: titleText, cta: buttonText, message: contentText },
        navigation: {
          type: 'section',
          options: {
            sectionId: pageId,
            appDefinitionId: OP_APP_DEF_ID,
            state: url,
          },
        },
      },
    },
  });
};
